import React, { useState, Fragment, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import styled from 'styled-components';
import * as _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import machineLarge from 'common/images/machineLarge.svg';
import SplashScreen from 'common/components/molecules/SplashScreen';

import * as sensorActions from '../../../Sensors/actions/sensors.actions';
import { getCurrentAccount } from '../../../../onboarding/user.actions';

const Page = styled.div`
  height: 100%;
  padding-top: 4rem;
`;


const AssociateSensors = (props) => {
  const { t } = useTranslation();

  useEffect(() => {
    const { getUnassociatedSensorsList, getSensorsMetadata } = props.sensorActions;
    props.setFooter(null);
    props.setTitle([props.machineName, t('machineBuilder.associateSensors.title')]);
    getUnassociatedSensorsList();
    getSensorsMetadata();
  }, []);

  return (
    <Page>
      <Fragment>
        <SplashScreen
          image={machineLarge}
          highlight={props.machineName}
          heading={() => (
            <Fragment>
              {t('machineBuilder.associateSensors.createdHeading', { machineName: props.machineName })}
            </Fragment>
          )}
          click={() => props.setShowSensorModal(true)}
          linkText={t('machineBuilder.associateSensors.cta')}
        >
          <Fragment>
            {t('machineBuilder.associateSensors.helpText')}
          </Fragment>
        </SplashScreen>
      </Fragment>
    </Page>
  );
};

const mapStateToProps = state => ({
  sensors: state.sensors,
  currentAccount: state.currentAccount,
  user: state.user.user
});

const mapDispatchToProps = dispatch => ({
  sensorActions: bindActionCreators(sensorActions, dispatch),
  getCurrentAccount: bindActionCreators(getCurrentAccount, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(AssociateSensors);
